// extracted by mini-css-extract-plugin
export default {"container":"JobCard_container__pI0Q-","card":"JobCard_card__4pZgv","jobGrid":"JobCard_jobGrid__1Do0E","addJobBtn":"JobCard_addJobBtn__qhkri"};